import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
    projectId: 'wm9wnf5g',
    dataset: 'production',
    apiVersion: '2023-02-21',
    useCdn: true,
    token: 'sktlvmkrJq2kDB5YMTSrQJEUaWOt6kRIz2RTWwi2AUtppmhDNtnONgIYQYJGzANbYzxr0C6hnzYkWgDCGE9Zb94sZ15Xy5qFLU6gjgvotbm2XaEw9hEpb1spIb1QjOORXTtq7lqv9w7xHAliP7LN1JlCNpLPbnDtnoAi4zP8U80RHauFg8y3',
    ignoreBrowserTokenWarning: true,
});
//console.log("check token", process.env.REACT_APP_SANITY_PROJECT_ID)
const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);